import { VdsSidenav, VdsSidenavItem } from '@volt/volt-extended-components-react';
import styles from './SideNav.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@casops/store/hooks';
import { useCallback, useState } from 'react';
import SideNavMenu from '../side-nav-menu/SideNavMenu';

export function SideNav() {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = useCallback(() => {
    setIsOpen(isOpen => !isOpen);
  }, []);

  return (
    <VdsSidenav
      showBrand={true}
      isAdaptable={false}
      expanded={isOpen && userData.isLoggedIn}
      mode="side"
    >
      <div slot="drawer" className={styles.sidenav}>
        <SideNavMenu isOpen={isOpen} />

        <div className={styles.spacer} />

        <VdsSidenavItem
          key="sidenav-expando"
          icon={isOpen ? 'chevron-left' : 'chevron-right'}
          expanded={isOpen}
          value={t('CollapseMenu')}
          isActive={false}
          onClick={toggleIsOpen}
        />
      </div>
    </VdsSidenav>
  );
}

export default SideNav;
